import { render, staticRenderFns } from "./MemberUpdateHistory.vue?vue&type=template&id=0c074bf1&scoped=true&"
import script from "./MemberUpdateHistory.vue?vue&type=script&lang=js&"
export * from "./MemberUpdateHistory.vue?vue&type=script&lang=js&"
import style0 from "./MemberUpdateHistory.vue?vue&type=style&index=0&id=0c074bf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c074bf1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VDataTable,VRow,VTextField})
